<div
  class="container-filter__padding"
  matMenuContent
  (click)="$event.stopPropagation()"
>
  <div class="item-filter">
    <div class="lista">
      <div class="item" *ngFor="let tarefa of listaStatusTarefa"
           style="cursor: pointer;">
        <mat-radio-button
          color="primary"
          class="filter-radio-margin"
          labelPosition="before"
          name="statusTarefa"
          [value]="tarefa.value"
          [checked]="statusSelecionado === tarefa.value"
          (change)="
            atualizaFiltroStatusTarefa.emit({
              tarefa: tarefa.value,
              newValue: true
            })
          "
        >
         <div style="position: absolute; width: 90%; height: 17%; cursor: pointer;"></div>
            <span class="filter-text" style="cursor: pointer">{{
              tarefa.viewValue
            }}</span>
        </mat-radio-button>
      </div>
    </div>
  </div>
</div>
